// @flow
import React from 'react';
import styled from 'styled-components';
import moment from 'moment'
import { formatPrice, formatVat } from '../../utils/price-utils'
import { formatDateRange } from '../../utils/date-utils';
import colors from '../common/components/ui/colors';
import withLocalized from '../localization/withLocalized';
import { renderDiscountPrice } from "./components/DiscountedPrice";

const StyledWrapper = styled.section`
  border: 1px solid #a7a7a7;
  border-radius: 4px;
  margin-bottom: 2.5rem;
  overflow: hidden;
`;

const StyledHeader = styled.header`
  display: flex;
  border-bottom: 1px solid #a7a7a7;
  align-items: center;
`;

// const StyledThumbnail = styled.figure`
//   width: 58px;
//   height: 58px;
//   align-self: flex-start;

//   img {
//     width: 100%;
//     height: auto;
//   }
// `;


const Figure = styled.figure`
  background: white;
  ${props => props.src && (`
    background-image: url(${props.src});
    background-position: 50% 50%;
    background-size: cover;
  `
  )}
  width: 58px;
  height: 58px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
`;

const StyledThumbnail = styled(({src, ...rest}) => {
  return (
    <Figure src={src}  {...rest} />
  );
})``;

const StyledTitle = styled.div`
  flex: 1;
  padding: 0 1rem;
  line-height: 1.2em;
  
  p {
    color: #969696;
    margin: 0;
    strong {
      color: ${colors.BRAND_GREEN};
    }
  }
`;

const StyledDescription = styled.div`
  padding: 0.75rem 1rem;
  font-size: 14px;
  line-height: 1.2em;
  p {
    margin-bottom: 1em;
  }
`;

const StyledFooter = styled.footer`
  padding: 0 0.75rem 0.5rem;
  
`;

const StyledPrice = styled.span`
  font-weight: 300;
  font-size: 2.25rem;
  color: ${colors.BRAND_GREEN};
`;

const StyledPriceDescription = styled.span`
  margin-left: 1em;
  color: #969696;
`;

const formatDescription = (description) => {
  let formatted = `<p>${description}</p>`;
  formatted = formatted.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
  formatted = formatted.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');

  return formatted;
}

const BookingDetails = (props) => {
  const { event, price, currency, vat, localized, localeConfig } = props;
  const { title, date_from, date_to, summary, image, type = [] } = event;
  const price_value =  price && price.price_value ? price.price_value : event.price;
  const formattedDates = formatDateRange(moment(date_from), moment(date_to));
  //const formattedPrice = `${price_value.replace('.', ',')} €`;
  const formattedPrice = formatPrice(price_value, currency, localeConfig('units.currency.locale'));
  const formattedDescription = formatDescription(summary);
  const imageSrc = image instanceof Array && image.length > 0 ? image[0].formatted_large : undefined;

  return (
    <StyledWrapper>
      <StyledHeader>
        {imageSrc && (
          <StyledThumbnail src={imageSrc} role="presentation" />
        )
        }
          <StyledTitle>
            <p><strong>{title}</strong><br />
            { !type.includes('Service') && formattedDates }
        </p>
        </StyledTitle>
        
      </StyledHeader>
      <StyledDescription>
        <div dangerouslySetInnerHTML={{__html: formattedDescription}}></div>
      </StyledDescription>
      <StyledFooter>
        { renderDiscountPrice(price, localeConfig) }
        <StyledPrice>
          {formattedPrice}
        </StyledPrice>
        {
          (() => {
            if (process.env.REACT_APP_NODE_ENV !== 'ie' && process.env.REACT_APP_NODE_ENV !== 'test') {
              return (
                <StyledPriceDescription>
                  {localized('booking.form.tax_info_text').replace('{value}', formatVat(vat))}
                </StyledPriceDescription>
              )
            }

          })()
        }
      </StyledFooter>
    </StyledWrapper>
  );
};

export default withLocalized(BookingDetails);



// WEBPACK FOOTER //
// ./src/modules/booking/BookingDetails.js